export const serviceTestId = {
  contactUs: {
    contactLink: "service-contact-us-contact-link",
  },
  top: {
    contactLink: "service-top-contact-link",
  },
} as const;
